// extracted by mini-css-extract-plugin
export default {"box":"AgentForm_box__VFRvA","textArea":"AgentForm_textArea__SseZ5"};